import { createSlice } from "@reduxjs/toolkit";
import { ENTITY_ID_KEY, saveItemToStorage } from "@jugl-web/utils/storage";

const getInitialState = () => ({
  sideBarVisible: true,
  entity: null,
});

const appSlice = createSlice({
  name: "app",
  initialState: getInitialState(),
  reducers: {
    setEntity: (state, { payload }) => {
      saveItemToStorage(ENTITY_ID_KEY, payload.id);
      state.entity = payload;
    },
  },
});

export const { setEntity } = appSlice.actions;

export default appSlice;
